import React, { useState } from 'react'
import prmsteptwoStyle from './PublisherRegisterMobilStepTwo.module.css'
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function PublisherRegisterMobilStepTwo() {

  // Password Eyes
  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };

  // Confirm Password Eyes
  const [isCPasswordVisible, setCPasswordVisible] = useState(false);

  const toggleCPasswordVisibility = () => {
    setCPasswordVisible(!isCPasswordVisible);
  };

  return (
    <>
      <div className={prmsteptwoStyle.publisherstepperTwo}>
        <div className='row'>
          <div className='col-7'>
            <h3> Choose a Password </h3>
          </div>
          <div className='col-5'> </div>
        </div>
        <h5> Password Information </h5>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={prmsteptwoStyle.publisherpasswordWrapper}>
                <input type={isPasswordVisible ? "text" : "password"} id="password-field" className={`${prmsteptwoStyle.publishertwoInputs} form-control`} placeholder='Choose your password' name="password" required />
                <div className={prmsteptwoStyle.pubsteptwotogglebutton} onClick={togglePasswordVisibility}>
                  {isPasswordVisible ? <FaEyeSlash className={prmsteptwoStyle.pubeyesiconColor} /> : <FaEye className={prmsteptwoStyle.pubeyesiconColor} />}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="mb-3">
              <div className={prmsteptwoStyle.publisherpasswordWrapper}>
                <input type={isCPasswordVisible ? "text" : "password"} id="password-field1" className={`${prmsteptwoStyle.publishertwoInputs} form-control`} placeholder='Confirm your password' name="confirmPassword" required />
                <div className={prmsteptwoStyle.pubsteptwotogglebutton} onClick={toggleCPasswordVisibility}>
                  {isCPasswordVisible ? <FaEyeSlash className={prmsteptwoStyle.pubeyesiconColor} /> : <FaEye className={prmsteptwoStyle.pubeyesiconColor} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
